<!-- FooterActionButtonsComponent: the billing screen's function-key action bar -->
<nav class="action-bar" aria-label="Billing actions">
  <button
    type="button"
    *ngFor="let action of actions"
    class="action-btn"
    [ngClass]="'action-btn--' + action.key"
    [disabled]="isDisabled(action)"
    (click)="onActionClick(action)"
    [title]="(action.title ?? getLabel(action)) + ' (' + action.shortcutKey + ')'"
    [attr.aria-keyshortcuts]="action.shortcutKey"
  >
    <i *ngIf="action.icon" [class]="action.icon" aria-hidden="true"></i>
    <span class="action-btn__label">{{ getLabel(action) }}</span>
    <span class="action-btn__key">{{ action.shortcutKey }}</span>
  </button>
</nav>
